import { ReactNode } from 'react';

interface SummaryItemProps {
  label: string;
  value: ReactNode;
  icon: ReactNode;
}

const SummaryItem = ({ label, value, icon }: SummaryItemProps) => {
  return (
    <div className='flex flex-col'>
      <span className='text-[11px] font-black text-gray-400 uppercase tracking-widest mb-1'>
        {label}
      </span>
      <div className='flex items-center gap-2 text-sm font-bold text-gray-700'>
        <div className='p-1.5 rounded-lg bg-orange-50 text-orange-600'>
          {icon}
        </div>
        {value}
      </div>
    </div>
  );
};

export default SummaryItem;
